import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
    @Prop([Object, Function]) public component!: any;
    @Prop(Object) public args?: any;

    public render(h: CreateElement): VNode {
        // <template>
        //     <div class="s-dialog">
        //         <div class="s-dialog-background"></div>
        //         <div class="s-dialog-content s-panel">
        //             !! component here !!
        //         </div>
        //     </div>
        // </template>

        return h(
            'div', { attrs: { class: 's-dialog' } },
            [
                h('div', { attrs: { class: 's-dialog-background' } }),
                h(
                    'div', { attrs: { class: 's-dialog-content s-panel' } },
                    [h(this.component, { props: this.args, on: this.$listeners })]
                )
            ]
        );
    }
}
